import _ from 'lodash';
import { getBlogs } from 'adapters/albumAdapter';
import { BLOG_META_DESCRIPTION, BLOG_META_TITLE } from 'constants';
import { readMore } from 'utils';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import HeroLayout from 'layouts/HeroLayout';
import Grid from '@mui/material/Grid';
import Link from 'next/link';
import makeClasses from 'hooks/useClasses';
import PageHead from 'components/Head/PageHead';
import PropTypes from 'prop-types';
import React from 'react';
import styles from 'styles/jss/pages/blogPostStyle';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

export const getStaticProps = async () => {
  const blogs = await getBlogs();
  return {
    props: { blogs }
  };
};

const BlogHome = ({ blogs }) => {
  const classes = makeClasses(styles);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const isMedium = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  let imageWidth = 600;
  if (isSmall) imageWidth = 600;
  else if (isMedium) imageWidth = 400;

  return (
    <>
      <PageHead title={BLOG_META_TITLE} description={BLOG_META_DESCRIPTION} />
      <Grid item container xs={12} spacing={4}>
        {blogs.map((blog) => (
          <Grid item xs={12} sm={6} md={4} key={blog.slug}>
            <Card className={classes.blogHomeCard}>
              <CardActionArea href={blog.url}>
                <CardMedia
                  component="img"
                  height="200"
                  image={`${blog.heroImage.url}?width=${imageWidth}`}
                  alt={blog.heroImage.imageTitle}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    className="blogTitle"
                  >
                    {blog.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    className="blogSummary"
                  >
                    {blog.summary}
                  </Typography>
                  <Button
                    disableRipple
                    sx={{
                      '&:hover': {
                        background: 'none'
                      }
                    }}
                  >
                    Read More
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

BlogHome.getLayout = (page) => {
  const firstBlog = _.get(page, 'props.blogs.0', {});
  const classes = makeClasses(styles);

  return (
    <HeroLayout
      heroImage={_.get(firstBlog, 'heroImage.url')}
      heroImageTitle={_.get(firstBlog, 'heroImage.imageTitle')}
      heroCtaStyle={{
        backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,1))'
      }}
      cta={(
        <Box className={classes.homeCta}>
          <Typography
            gutterBottom
            variant="pageTitle"
            color="primary"
            component="div"
            className="blogTitle"
          >
            {readMore(firstBlog.title, 10)}
          </Typography>
          <Typography
            variant="body2"
            color="white"
            className="blogSummary"
          >
            {firstBlog.summary}
          </Typography>
          <Link href={firstBlog.url} passHref>
            <Button variant="contained" size="large" sx={{ mt: 3 }}>
              Read More
            </Button>
          </Link>
        </Box>
      )}
    >
      {page}
    </HeroLayout>
  );
};

BlogHome.propTypes = {
  blogs: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default BlogHome;
